import { useNavigate } from "react-router-dom";
import { useActivityCounts } from "@/hooks/useActivityCounts";
import { Clock, CalendarCheck, ArrowRight, Loader2 } from "lucide-react";

export function CalendarNavMenu() {
  const navigate = useNavigate();
  const { missedCount, todayCount, upcomingCount, isLoading } = useActivityCounts();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-3 px-2">
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
        <span className="ml-2 text-sm text-muted-foreground">Loading...</span>
      </div>
    );
  }

  const items = [
    {
      label: "Today",
      count: todayCount,
      view: "today",
      icon: CalendarCheck,
    },
    {
      label: "Missed",
      count: missedCount,
      view: "missed",
      icon: Clock,
    },
    {
      label: "Today+",
      count: upcomingCount,
      view: "upcoming",
      icon: ArrowRight,
    },
  ];

  return (
    <div className="min-w-[180px]">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.view}
            onClick={() => navigate(`/activities?view=${item.view}`)}
            className="flex items-center justify-between text-sm py-1.5 px-2 rounded hover:bg-accent cursor-pointer"
          >
            <div className="flex items-center gap-2">
              <Icon className="h-3.5 w-3.5 text-muted-foreground" />
              <span>{item.label}</span>
            </div>
            <span className="text-xs bg-muted rounded-full px-1.5">
              {item.count}
            </span>
          </div>
        );
      })}
    </div>
  );
}
